
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { v4 as generateUuid } from "uuid"

import * as cdn from "@coredination/components"
import RemoteSignatureDetail from "@/graphql/job/remotesignaturedetail.graphql"
import CancelRemoteSignature from "@/graphql/job/cancelremotesignature.graphql"
import SendRemoteSignatureReminder from "@/graphql/job/sendremotesignaturereminder.graphql"

import { Formatting } from "../../util/formatting"
const dateFormat: any = new Formatting.DateFormatting()

@Component({
    components: {
        AreYouSureDialog: () => import("@/components/dialogs/AreYouSureDialog.vue"),
    },
    apollo: {
        remoteSignature: {
            query: RemoteSignatureDetail,
            skip() {
                return !this.id
            },
            variables() {
                return { id: this.id }
            },
            result(result) {
                this.remoteSignature?.events?.sort(function(a: any,b: any){
                    return b.eventTimeStamp - a.eventTimeStamp
                })
                console.log(result)
            },
        },
    },
})
export default class RemoteSignatureView extends Vue {
    @Prop()
    id?: string
    remoteSignature?: any
    showAreYouSure: boolean = false
    sendingReminder: boolean = false

    confirmCancel(){
        this.showAreYouSure = true
    }

    getEventTime(timeStamp: any){
        if (this.showEventDates()) return dateFormat.dateCustomFormat(timeStamp, "yy-mm-dd HH:mm")
        return dateFormat.time(timeStamp)
    }

    getEventName(event: any){
        if (!event?.type) return ""
        if ((event.type == "CREATE" || event.type == "CANCEL") && this.remoteSignature?.consignor?.name) {
            return this.remoteSignature.consignor.name
        }
        if (this.remoteSignature.notifySignersBy == "SMS") {
            var name = event?.signer?.name || this.remoteSignature?.signer?.name
            var phone = event?.signer?.phoneNo || this.remoteSignature?.signer?.phoneNo
            return name && phone ? name + ", " + phone : phone ? phone : name ? name : ""
        }
        return event?.signer?.emailAddress || this.remoteSignature?.signer?.emailAddress || ""
    }


    showEventDates(){
        if (this.remoteSignature?.events?.length > 0 && !dateFormat.isToday(this.remoteSignature.events[0]?.eventTimeStamp)) return true
        return false
    }

    cancel(){
        if (this.id) {
            this.$apollo
                .mutate({
                    mutation: CancelRemoteSignature,
                    variables: {
                        id: this.id
                    },
                    update(proxy, response) {
                        const hackProxy = proxy as any
                        Object.keys(hackProxy.data.data).forEach(key => {
                            if (key.match(/(myJobs|myWorkStats)/)) hackProxy.data.delete(key)
                        })
                    }
                })
                .then(async response => {
                    console.log('signature was successfully canceled')
                    this.remoteSignature.deleted = true
                    this.$router.back()
                })
                .catch((error: any) => {
                    console.error(`Could not cancel signature: ${error}`)
                })
        }
    }

    sendReminder() {
        var id = this.id
        var token: string = this.remoteSignature?.signer?.token
        if (!id || !token) return
        this.sendingReminder = true
        this.$apollo
            .mutate({
                mutation: SendRemoteSignatureReminder,
                variables: {
                    id: id,
                    token: token,
                },
                update(proxy, response) {
                    const hackProxy = proxy as any
                    Object.keys(hackProxy.data.data).forEach(key => {
                        if (key.match(/(myJobs|myWorkStats)/)) hackProxy.data.delete(key)
                        if (key.match(/(remoteSignature)/)) {
                            hackProxy.data.delete(key)
                        }
                    })
                }
            })
            .then(async response => {
                console.log('reminder sent')
            })
            .catch((error: any) => {
                console.error(`could not send reminder: ${error}`)
            })
            .finally(() => {
                setTimeout(() => {
                    this.sendingReminder = false
                }, 600)
            })
    }

    lastReminded() {
        if (!this.remoteSignature || !this.remoteSignature.events || this.remoteSignature.events.length == 0)
            return null
        var remindEvents: any[] = this.remoteSignature.events.filter((event: any) => event.type == "REMIND")
        if (!remindEvents || remindEvents.length == 0)
            return null
        var latest = remindEvents[0]
        return this.getEventTime(latest.eventTimeStamp)
    }

    getColor(){
        const state = this.remoteSignature.state
        if (state == "INITIAL" || state == "OPENED" || state == "PARTIAL") return "#f3f3d1"
        if (state == "DECLINED" || state == "CANCELLED") return "#ebdacf"
        if (state == "COMPLETED") return "#daebcf"
        return ""
    }

    canRemind() {
        if (!this.remoteSignature)
            return false
        var state: string = this.remoteSignature.state
        var signer: any = this.remoteSignature.signer
        return state && signer && !['COMPLETED', 'CANCELLED', 'DECLINED'].includes(state) && signer.remindCount < 5;
    }

    get signedText(){
        var name = this.remoteSignature?.signer?.name || this.remoteSignature?.signer?.emailAddress
        var time = this.signedTimeStamp()
        var deliveryMethod = this.remoteSignature?.notifySignersBy ? this.$t('_notifyBy_' + this.remoteSignature?.notifySignersBy) : null
        var phoneNoOrEmail
        if (this.remoteSignature?.notifySignersBy == "EMAIL" && this.remoteSignature?.signer?.emailAddress){
            phoneNoOrEmail = this.remoteSignature?.signer?.emailAddress
        }
        else if (this.remoteSignature?.notifySignersBy == "SMS" && this.remoteSignature?.signer?.phoneNo){
            phoneNoOrEmail = this.remoteSignature?.signer?.phoneNo
        }
        if (phoneNoOrEmail) phoneNoOrEmail = "(" + phoneNoOrEmail + ")"
        if (deliveryMethod && name && time) return this.$t('remoteSignature_sentBySignedBy', {deliveryMethod: deliveryMethod, name: name, time: time, phoneNoOrEmail: phoneNoOrEmail})
        if (name && time) return this.$t('remoteSignature_signedByText', {name: name, time: time})
        return this.$t('remoteSignature_signedText')
    }

    goToDocument() {
        window.location.href = this.contentUrl
    }

    get contentUrl() {
        if (!this.remoteSignature?.signedDocument?.contentUrl) return ""
        var url = this.remoteSignature.signedDocument.contentUrl
        if (url.indexOf("http") != 0) {
            url = (process?.env?.VUE_APP_BACKEND_URL || "http://localhost:8080") + url
            if (localStorage["apollo-token"]) url += "?api_token=" + localStorage["apollo-token"]
        }
        return url
    }

    signedTimeStamp() {
        var state = this.remoteSignature && this.remoteSignature.state;
        if (!state || state != 'COMPLETED') return null;
        var signedTimeStamp = this.remoteSignature && this.remoteSignature.signer.signedTimeStamp;
        if (!signedTimeStamp) return null;
        return dateFormat.date(signedTimeStamp, null, false);
    }
}
